<template>
    <div id='schedule'>
        <!--    <template v-if="showPage == 1">  </template>-->
        <div class='search-input-wrap'>
            <el-row class='search-input-row y_Schedule_flex' style="margin-bottom: 20px;">
                <el-col :span='span'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">物料编码：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.materialCode"
                                @change="testNum"
                                placeholder="物料编码">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span='span'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">订单编号：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.orderCode"
                                @change="testNum"
                                placeholder="订单编号">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span='span'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">生产单号：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.productionCode"
                                @change="testNum"
                                placeholder="生产单号">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span='span' v-if='W'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">工艺路线：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.routeName"
                                @change="testNum"
                                placeholder="工艺路线">
                        </el-input>
                    </div>
                </el-col>
            </el-row>
            <el-row class='search-input-row y_Schedule_flex'>
                <el-col :span='span' v-if='!W'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">工艺路线：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.routeName"
                                @change="testNum"
                                placeholder="工艺路线">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span='span'>
                    <div class="span_flex">
                        <span class="title">生产形式：</span>
                        <el-select clearable
                                   style="max-width:180px"
                                   filterable
                                   :loading="workerLoading"
                                   v-model='searchForm.productionType'
                                   size='small' maxlength='16' placeholder='生产形式'
                                   :filter-method='filterUser'
                                   @change='workerSelectChange'
                                   @visible-change='closeSelect'
                                   @keyup.enter.native='search'>
                            <el-option
                                    v-for="item in workerCopy"
                                    :key="item.id"
                                    :value="item.value"
                                    :label="item.label">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span='span'>
                    <div class="span_flex">
                        <span class="title">任务进度：</span>
                        <el-select clearable
                                   style="max-width:180px"
                                   filterable
                                   :loading="workerLoading"
                                   v-model='searchForm.processType'
                                   size='small' maxlength='16' placeholder='任务进度'
                                   :filter-method='filterUser'
                                   @change='workerSelectChange'
                                   @visible-change='closeSelect'
                                   @keyup.enter.native='search'>
                            <el-option
                                    v-for="item in productionList"
                                    :key="item.id"
                                    :value="item.value"
                                    :label="item.label">
                            </el-option>
                            <div v-if="productionList.length > 48" class="search-keyword" style="text-align:center">
                                <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                            </div>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span='W?span:6' v-if='W'>
                    <div class="span_flex">
                        <span class="title">按序报工：</span>
                        <el-select style="max-width:180px" v-model="searchForm.postInOrder" clearable
                                   placeholder='按序报工'>
                            <el-option key="0" value="0" label="否"></el-option>
                            <el-option key="1" value="1" label="是"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span='span' v-if='W'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">批次号：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.productionBatchCode"
                                @change="testNum"
                                placeholder="批次号">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span='W?(24-4*span):4' v-if='W'>
                    <div style="text-align:right" class="span_flex">
                        <el-button type='primary' icon="el-icon-search" size='mini' @click='clickSearch'>查询</el-button>
                        <el-button size='mini' icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-row class='search-input-row y_Schedule_flex' v-if='!W' style="margin-top: 20px;">
                <el-col :span='W?span:6'>
                    <div class="span_flex">
                        <span class="title">按序报工：</span>
                        <el-select style="max-width:180px" v-model="searchForm.postInOrder" clearable
                                   placeholder='按序报工'>
                            <el-option key="0" value="0" label="否"></el-option>
                            <el-option key="1" value="1" label="是"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span='span'>
                    <div @keydown.enter="clickSearch()" class="span_flex">
                        <span class="title">批次号：</span>
                        <el-input
                                style="max-width:180px"
                                size="small"
                                v-model="searchForm.productionBatchCode"
                                @change="testNum"
                                placeholder="批次号">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span='(24-2*span)'>
                    <div style="text-align:right">
                        <el-button type='primary' icon="el-icon-search" size='mini' @click='clickSearch'>查询</el-button>
                        <el-button size='mini' icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-row class='tab'>
            <el-row class='table-wrap'>
                <el-table :data='tableData' tooltip-effect='dark' :default-sort='defaultSort' class="y_Public_table"
                          @sort-change='sortChangeEvent' :header-cell-class-name='handlemyclass'>
                    <el-table-column prop='productionBatchCode' label='批次号' min-width='60'
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="materialCode" label='物料编码' min-width='100'
                                     cell-mouse-enter  show-overflow-tooltip></el-table-column>
                    <el-table-column prop='materialName' label='物料名称' min-width='100'
                                     >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.materialName" placement="top">
                                <div class="y_clamp">
                                    <div>{{scope.row.materialName}}</div>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop='orderCode' label='订单编号' min-width='100'
                                    >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.orderCode" placement="top">
                                <div class="y_clamp">
                                    <div>{{scope.row.orderCode}}</div>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop='productionCode' label='生产单号' min-width='100'
                                    >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.orderCode" placement="top">
                                <div class="y_clamp">
                                    <div>{{scope.row.orderCode}}</div>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop='amount' label='数量' min-width='50' max-width="70"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label='单位' min-width='50' max-width="70"
                                     prop="unitOfQuantity"  show-overflow-tooltip>

                        <!--            <template slot-scope="scope">-->
                        <!--&lt;!&ndash;              <span>{{scope.row.itemType | showType}}</span>&ndash;&gt;-->
                        <!--            </template>-->
                    </el-table-column>
                    <!--          <el-table-column prop='tcheckState' label='' style="display: none" max-width="1"-->
                    <!--                           show-overflow-tooltip>-->
                    <!--            <span style="display: none"></span>-->

                    <!--          </el-table-column>-->
                    <!--          <el-table-column prop='alreadyInStockAmount' label='' style="display: none" max-width="1"-->
                    <!--                           show-overflow-tooltip>-->
                    <!--            <span style="display: none"></span>-->
                    <!--          </el-table-column>-->

                    <el-table-column prop='productionType' label='生产形式' min-width='100' :formatter="parseProductionType"
                                     show-overflow-tooltip>

                    </el-table-column>
                    <el-table-column prop="process" label='任务进度' min-width='100' sortable="custom"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-progress :class="scope.row.class" :text-inside="true" :stroke-width="18"
                                         :color="scope.row.color"
                                         :percentage="scope.row.process"></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column prop='routeName' label='工艺路线' min-width='100'
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ (scope.row.productionType ==  1 || scope.row.productionType == 3)?scope.row.routeName:''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='按序报工' min-width='100'
                                     prop="postInOrder"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.postInOrder | PostInOrder}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='操作' fixed="right"  min-width='220' max-width="280" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button v-if="0<=scope.row.process<=100 " @click="printOrderList($event,scope.row)"
                                       type="text"
                                       size="small" style="vertical-align: unset;cursor: pointer">打印
                            </el-button>
                            <el-button
                                    v-if="scope.row.process!==100&&permission.btn_plan_create&&showState(scope)"
                                    type="text" size="small" @click="showProductionPlanEdit(scope.row)"
                                    style="vertical-align: unset;">编排任务
                            </el-button>

                            <el-button v-if="0<=scope.row.process<=100|| !permission.btn_plan_create" type="text"
                                       size="small"
                                       @click="showProductionPlanView(scope.row)"
                                       style="cursor: pointer;vertical-align: unset;">进度查看
                            </el-button>
                            <el-button v-if="showCall(scope)&&permission.btn_stockIn_apply"
                                       @click="showStore(scope.row)" type="text"
                                       size="small" style="cursor: pointer;color:#409EFF;vertical-align: unset;">物料入库
                            </el-button>
                            <!--              v-if="(permission.btn_stockIn_apply)&&(scope.row.stockInButtonStatus==1)"-->
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <!--      <div class="page" v-if="page.isShow">-->
            <!--        <div class="total_page"><span> 共{{page.total}}条 </span></div>-->
            <!--        <div style="margin-top:10px;text-align:right; margin-bottom:20px;">-->
            <!--          <el-pagination background layout="prev, pager, next" :total="page.total" @current-change="pageChange"-->
            <!--                         :page-sizes="[10, 20, 30, 50,100]"-->
            <!--                         :current-page="page.currentPage">-->
            <!--          </el-pagination>-->
            <!--        </div>-->
            <!--      </div>-->
            <div class="page" v-if="tableData.length > 0">
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                    <el-pagination background @size-change="sizeChange"
                                   layout=" total, sizes, prev, pager, next, jumper"
                                   :page-count="page.total"
                                   :page-sizes="[10, 20, 30, 50,100]"
                                   :page-size.sync="page.pageSize"
                                   :total="page.total" @current-change="pageChange"
                                   :current-page.sync="tableCurrentPage"></el-pagination>
                </div>

                <!-- <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                    <el-pagination background layout="prev, pager, next"
                    :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                    </el-pagination>
                </div> -->
            </div>
        </el-row>


        <!-- <el-row class='operateBtn-wrap'>
            <el-button v-if="!W&&permission.btn_plan_exportProductionPlan" size='mini'  @click='exportList'>导出<i class="el-icon-download el-icon--right"></i></el-button>
        </el-row> -->


        <!--    <template v-if="showPage == 2">-->
        <!--      <ProductionPlanEdit :selectedSplit="selectedSplit"></ProductionPlanEdit>-->
        <!--    </template>-->
        <!--    <template v-if="showPage == 3">-->
        <!--      <ProductionProgressView :selectedSplit="selectedSplit"></ProductionProgressView>-->
        <!--    </template>-->
        <!--    <template v-if="showPage == 1">-->
        <!--      <ScheduleTaskView  :selectedOrder="selectedOrder"></ScheduleTaskView>-->
        <!--    </template>-->
        <!--    以下是打印弹窗开始-->
        <el-dialog title="打印流转卡" center :visible.sync="showPrintDialog" :width="W?'60%':'70%'"
                   :close-on-click-modal="false">
            <el-form :model="printForm" :rules="rules" ref="printForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:10px">
                    <el-col :span="8">
                        <span class="titel">流转卡模板：</span>
                        <el-form-item class="value" style="max-width:180px">
                            <el-select size="small" v-model="printForm.modelType" style="display:block">
                                <el-option label="模板1" :value="0"></el-option>
                                <el-option label="模板2" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-table :header-cell-class-name='headStyle' :height="height" ref='print-table' :data="printModelData"
                          :cell-class-name='cellStyle' stripe style="width: 100%;margin-bottom:10px;"
                          class="printModel-table"
                          @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" :selectable='selectable'>
                    </el-table-column>
                    <el-table-column label="物料名称" min-width="100" prop="materialName" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item class="ellipsis-text">
                                <span>{{scope.row.materialName}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="物料编码" prop="materialCode" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item class="ellipsis-text">
                                <span>{{scope.row.materialCode}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" min-width="100" prop="unitOfQuantity">
                        <template slot-scope="scope">
                            <el-form-item class="ellipsis-text">
                                <span>{{scope.row.unitOfQuantity}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="可打印数量" min-width="80" prop="remainAmount">
                        <template slot-scope="scope">
                            <el-form-item>
                                {{scope.row.remainAmount}}
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="生产形式" prop="productionType" min-width="70">
                        <template slot-scope="scope">
                            <el-form-item>
                                {{scope.row.productionType|filterProductionType}}
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工艺路线" min-width="80" prop="routeName" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item class="ellipsis-text">
                                <span>{{(scope.row.productionType==1||scope.row.productionType==3)?scope.row.routeName:''}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="每份数量" min-width="120" prop="itemName">
                        <template slot-scope="scope">
                            <el-form-item class="y_inputWidth" :prop="'printModelData.'+scope.$index"
                                          :rules="rules.amountPer">
                                <el-input :disabled="scope.row.productionType==2||scope.row.productionType==4"
                                          @input="amountPerChange($event,scope)" size="small" maxlength="30"
                                          v-model="scope.row.amountPer"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="剩余数量" min-width="70" prop="residualAmount" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item style="text-align: center">
                                {{scope.row.residualAmount}}
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="打印份数" min-width="120" prop="amount">
                        <template slot-scope="scope">
                            <el-form-item class="y_inputWidth" :prop="'printModelData.'+scope.$index"
                                          :rules="rules.amount1">
                                <el-input :disabled="scope.row.productionType==2||scope.row.productionType==4"
                                          @input="amountChange($event,scope)" size="small" maxlength="30"
                                          v-model="scope.row.amount"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitPrintDialog">提 交</el-button>
                <el-button @click="cancelPrintDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!--    以上是打印弹窗结束-->
        <!--    以下是物料入库弹窗开始-->
        <el-dialog title="物料入库" center :visible.sync="showStoreDialog" :width="W?'50%':'63%'"
                   :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">物料名称：</span>
                        <el-form-item class="value y_table_cell">
                            <span>{{addForm.materialName}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">已入库数：</span>
                        <el-form-item class="value y_table_cell" style="max-width:180px">
                            <span>{{addForm.alreadyInAmount}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">入库单位：</span>
                        <el-form-item class="value y_table_cell" style="max-width:180px">
                            <span>{{addForm.nameOfUnitType}}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">入库数量：</span>
                        <el-form-item prop="amount" class="value y_table_cell">
                            <el-input size="small" style="min-width:100px" v-model="addForm.amount" maxlength="50"
                                      placeholder="点检名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">入库批次：</span>
                        <el-form-item class="value y_table_cell" prop="productionBatch" style="min-width:100px">
                            <el-autocomplete class="value" :fetch-suggestions="querySearch" size="small"
                                             v-model="addForm.productionBatch"
                                             placeholder="请选择或输入批次" @input="selectBatch">
                            </el-autocomplete>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">入库时间：</span>
                        <el-form-item class="value y_table_cell" style="min-width:100px" id='store-time'>
                            <el-date-picker style="width:186px;" v-model="addForm.timeOfStockIn" type="datetime"
                                            value-format='yyyy-MM-dd HH:mm:ss' placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px">
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">顶级仓库：</span>
                        <el-form-item class="value y_table_cell" style="min-width:100px">
                            <el-select @change="warehouseChange" size="small" v-model="addForm.topWarehouseId"
                                       placeholder="顶级仓库"
                                       style="display:block">
                                <el-option v-for="item in tree" :key="item.id" :label="item.warehouseName"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="y_table">
                        <span class="titel y_table_span">子级仓库：</span>
                        <el-form-item class="value y_table_cell" prop="warehouseId" style="min-width:100px">
                            <el-select size="small" v-model="addForm.warehouseId" placeholder="子级仓库"
                                       style="display:block">
                                <el-option v-for="item in warehouseList" :key="item.id" :label="item.warehouseName"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <span style="width:60px" class="title">入库备注</span>
                    <el-input type="textarea" maxlength="255" :show-word-limit='true' v-model="addForm.remark"
                              :rows="3"></el-input>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitEditDialog">提 交</el-button>
                <el-button @click="cancelEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!--    以上是物料入库弹窗结束-->
    </div>
</template>

<script>
    import QrcodeVue from 'qrcode.vue';
    import pinyinMatch from 'pinyin-match'
    import CommonUtils from '../util/CommonUtils';
    // import OrderProductView from "./order/OrderProductView";
    // import ProductionPlanEdit from "./order/ProductionPlanEdit.vue";
    // import ProductionProgressView from "./order/ProductionProgressView.vue";


    export default {
        name: 'Schedule',
        data() {
            let that = this
            return {
                mouseData: [],
                searchCase: {},
                selectRow: {},
                height: ' ',
                printModelData: [],
                printForm: {
                    modelType: 0,
                    printModelData: []
                },
                tree: [],
                tableCurrentPage: 1,
                warehouseList: [],
                showPrintDialog: false,
                showStoreDialog: false,
                showPage: 1,
                show: false,
                selectedOrder: null,
                selectedSplit: null,
                addForm: {
                    materialName: "",
                    materialCode: "",
                    materialId: null,
                    nameOfUnitType: '',
                    alreadyInAmount: 0,
                    couldInAmount: 0,
                    batchList: [],
                    unitTypeId: null,
                    warehouseId: null,
                    remark: '',
                    topWarehouseId: '',
                    amount: 0,
                    selectedSplit: null,
                    productionBatch: "",
                    productionBatchId: null,
                    timeOfStockIn: null,
                },
                rules: {
                    productionBatch: [
                        {required: true, message: '请选择物料批次', trigger: ['blur', 'change']}
                    ],
                    warehouseId: [
                        {required: true, message: '请选择子级仓库', trigger: 'blur'}
                    ],
                    amount: [
                        {required: true, message: '请输入入库数量', trigger: 'blur'},
                        {
                            validator(rule, value, callback) {
                                if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                    if (value > that.addForm.couldInAmount) {
                                        callback(new Error(`入库数量不能大于最大可入库数量(${that.addForm.couldInAmount})`))
                                    } else {
                                        callback()
                                    }
                                } else {
                                    callback(new Error('请输入正整数'))
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    amountPer: [
                        {required: true, message: '请输入每份数量', trigger: 'blur'},
                        {
                            validator(rule, item, callback) {
                                let value = item.amountPer
                                if (item.remainAmount == 0) {  //不验证可用数量为0的数据

                                    callback()
                                } else {
                                    if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                        if (value > item.remainAmount) {
                                            callback(new Error(`每份数量不能大于可打印数量(${item.remainAmount})`))
                                        } else {
                                            callback()
                                        }
                                    } else {
                                        callback(new Error('请输入正整数'))
                                    }
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    amount1: [
                        {required: true, message: '请输入打印份数', trigger: 'blur'},
                        {
                            validator(rule, item, callback) {
                                let value = item.amount
                                if (item.remainAmount == 0) {  //不验证可用数量为0的数据
                                    callback()
                                } else {
                                    if (Number.isInteger(Number(value)) && Number(value) > 0) {
                                        if (value > item.remainAmount) {
                                            callback(new Error(`打印份数不能大于可打印数量(${item.remainAmount})`))
                                        } else {
                                            if (value * item.amountPer > item.remainAmount) {
                                                callback(new Error(`每份数量*打印份数不能大于可打印数量(${item.remainAmount})`))
                                            } else {
                                                callback()
                                            }
                                        }
                                    } else {
                                        callback(new Error('请输入正整数'))
                                    }
                                }
                            }, trigger: 'blur'
                        }
                    ]
                },
                fristLoad: false,
                qrOrderCode: '',
                qrProductionOrderCode: '',
                qrProductCode: '',
                qrPartCode: '',
                qrCode: '',
                qrCodeDialogVisible: false,
                productLoading: false,
                productionList: [
                    {
                        value: 0,
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '未完成'
                    },
                    {
                        value: 2,
                        label: '已完成'
                    }

                ],
                isSumbit: true,
                W: false,
                searchInputSpan: 4,
                searchSelectSpan: 5,
                // searchConditionSpan: 24/4,


                searchForm: {
                    materialCode: '',
                    orderCode: '',
                    productionCode: '',
                    productionType: null,
                    routeName: '',
                    postInOrder: null,
                    processType: null,
                    tcheckState: null,
                    alreadyInStockAmount: null,
                    productionBatchCode: '',
                },
                tableData: [],
                dongData: [
                    {
                        materialId: 58254,
                        unitTypeId: 4664,
                        unitOfQuantity: "个",
                        materialCode: "25234水水水水是是是水水水水是是是所所所所所所所所所水水水水是是是所所所所所所呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜无水水水水是是是所所所所所",
                        materialName: "78olSSSSSSSSSSSS撒大声地哒哒哒哒哒哒多多多多多多多多多呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜呜"
                    },
                    {
                        materialId: 58254,
                        unitTypeId: 4664,
                        unitOfQuantity: "个",
                        materialCode: "25234",
                        materialName: "78ol"
                    },
                    {
                        materialId: 58254,
                        unitTypeId: 4664,
                        unitOfQuantity: "个",
                        materialCode: "25234",
                        materialName: "78ol"
                    },
                    {
                        materialId: 58254,
                        unitTypeId: 4664,
                        unitOfQuantity: "个",
                        materialCode: "25234",
                        materialName: "78ol"
                    },
                    {
                        materialId: 58254,
                        unitTypeId: 4664,
                        unitOfQuantity: "个",
                        materialCode: "25234",
                        materialName: "78ol"
                    },
                    {
                        materialId: 58254,
                        unitTypeId: 4664,
                        unitOfQuantity: "个",
                        materialCode: "25234",
                        materialName: "78ol"
                    }
                ],
                orderType: 'DESC',//排序类型
                orderColumn: 'process',//排序列
                defaultSort: {prop: 'process', order: 'descending'},//默认排序设置
                page: {
                    isShow: false,
                    total: 0,
                    currentPage: 1,
                    pageSize: 10,
                },
                buttonSize: 'small',//按钮的大小
                showImportOrderView: false,
                orderLoading: false,
                orderOptions: [],
                deviceLoading: false,
                deviceOptions: [],
                workerLoading: false,
                workerOptions: [],
                workerCopy: [
                    {
                        value: 1,
                        label: '自产'
                    },
                    {
                        value: 2,
                        label: '外协'
                    },
                    {
                        value: 3,
                        label: '自产+外协'
                    },
                    {
                        value: 4,
                        label: '外购'
                    }
                ],

                selectList: [],

                selectOrderName: '',
                permission: JSON.parse(localStorage.getItem("permission"))
            }
        },

        //el和data尚未初始化
        beforeCreate: function () {
        },
        //data初始化完成
        created: function () {
        },
        //el初始化完成
        beforeMount: function () {
            // this.show = true
        },
        //完成挂载
        mounted: function () {
            // this.showPage = 2;
            this.orderRemoteMethod();
            this.deviceRemoteMethod();
            this.workerRemoteMethod();
            this.loadProductionCode()
            this.search(1)
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
            window.onresize = () => {
                let w = document.documentElement.clientWidth || document.body.clientWidth;
                w >= 1900 ? this.W = true : this.W = false
            }
        },
        //更新dom时触发
        beforeUpdate: function () {
        },
        updated: function () {
        },
        // activated: function(){
        //   console.log('activated',this.$root.$el.parentNode.children[2])
        // },
        // deactivated: function(){
        //   console.log('deactivated')
        // },
        beforeDestroy: function () {
        },
        destroyed: function () {
        },
        components: {
            QrcodeVue,
            // OrderProductView,
            // ProductionPlanEdit,
            // ProductionProgressView
        },
        computed: {
            span() {
                return this.W ? 5 : 6
            }
        },
        methods: {

            sizeChange(ev) {
                this.pageSize = ev
                this.search();
            },

            amountPerChange(ev, scope) {
                if (ev) {
                    let amount = parseInt(scope.row.remainAmount / ev)
                    let residualAmount = scope.row.remainAmount % ev
                    this.$set(this.printModelData[scope.$index], 'amount', amount)
                    this.$set(this.printModelData[scope.$index], 'residualAmount', residualAmount)
                }

            },

            amountChange(ev, scope) {
                if (ev) {
                    let amountPer = parseInt(scope.row.remainAmount / ev)
                    let residualAmount = scope.row.remainAmount % ev
                    this.$set(this.printModelData[scope.$index], 'amountPer', amountPer)
                    this.$set(this.printModelData[scope.$index], 'residualAmount', residualAmount)
                }
            },
            async printOrderList1(row) {
                this.search();
                let routeUrl = this.$router.resolve({path: "/printAllOrder",});
                window.open(routeUrl.href, '_blank');
            },
            cancelPrintDialog() {
                this.showPrintDialog = false
            },
            selectable(row, index) {
                if (row.remainAmount > 0) {
                    return true
                } else {
                    return false
                }
            },
            cellStyle({row, column, rowIndex, columnIndex}) {
                if (columnIndex == 0) {
                    return 'cell-class test-margin'
                } else {
                    return 'test-margin'
                }
            },
            handleSelectionChange(ev) {
                this.selectList = ev
            },
            headStyle({row, column, rowIndex, columnIndex}) {
                if (columnIndex == 0) {
                    return 'head-cell-class'
                }
            },

            async printOrderList(ev, rowData) {
                this.selectRow = rowData
                let data = [CommonUtils.cloneObj(rowData)]
                log(data)
                data.forEach(item => {
                    item.amountPer = item.remainAmount
                    item.amount = 1
                    item.residualAmount = 0
                })
                log(data)
                this.printModelData = data
                this.height = data.length >= 5 ? 356 : ' '
                this.$set(this.printForm, 'printModelData', data)

                this.printForm.modelType = 0
                this.showPrintDialog = true
                this.$nextTick(() => {
                    this.$refs['printForm'].clearValidate()
                    for (let i = 0; i < this.printModelData.length; i++) {
                        if (this.printModelData[i].remainAmount > 0) {
                            this.$refs['print-table'].toggleRowSelection(this.printModelData[i])
                        }
                    }
                })
            },

            async printTaskList(row) {

            },
            // showEdit(scope) {
            //   if (scope.row.partProcessRatio == "100") {
            //     return false;
            //   } else {
            //     if (
            //       (scope.row.hasProcedure && scope.row.hasProcedure != -1) ||
            //       scope.row.productionType == 4 ||
            //       scope.row.productionType == 2
            //     ) {
            //       return true;
            //     } else {
            //       return false;
            //     }
            //   }
            // },


            async printSeeList() {

            },
            // async printMaterialsList(){
            //   this.showMaterialDialog = true
            //
            // },
            async showStore(rowData) {
                let data = await this.loadMaterialInfo(rowData.splitId, rowData.materialId)
                this.addForm.materialId = data.materialId
                // this.addForm.splitId = data.splitId
                this.addForm.materialName = data.materialName
                this.addForm.materialCode = data.materialCode
                this.addForm.nameOfUnitType = data.nameOfUnitType
                this.addForm.alreadyInStockAmount = data.alreadyInStockAmount || data.alreadyInAmount
                this.addForm.couldInAmount = data.couldInAmount
                this.addForm.batchList = data.batchList
                this.addForm.unitTypeId = data.unitTypeId
                this.addForm.amount = data.couldInAmount
                this.addForm.splitId = rowData.splitId
                this.addForm.timeOfStockIn = new Date()
                await this.loadStoreList()
                this.showStoreDialog = true
            },
            querySearch(queryString, cb) {
                var restaurants = this.addForm.batchList;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                if (restaurants) {
                    results.forEach(item => {
                        item.value = item.productionBatch
                    })
                }
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    if (restaurant.productionBatch) {
                        return (restaurant.productionBatch.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
                    }
                };
            },
            selectBatch(ev) {
                if (this.addForm.batchList.length > 0) {
                    this.addForm.batchList.forEach(item => {
                        if (ev == item.productionBatch) {
                            this.addForm.productionBatchId = item.id
                        } else {
                            this.addForm.productionBatchId = null
                        }
                    })
                }
            },
            async submitPrintDialog() {
                this.search();
                this.$refs['printForm'].validate(async (valid) => {
                    if (valid) {
                        if (this.selectList.length == 0) {
                            this.$message.warning('请选择打印物料')
                            return false
                        }
                        let data1 = this.selectList.map(item => {
                            let json = {}
                            json.splitId = item.splitId
                            json.amountPer = item.amountPer
                            json.amount = item.amount
                            return json
                        })
                        let templateType = Number(this.printForm.modelType) + 1
                        let params = {
                            templateType: templateType,
                            orderId: this.selectRow.orderId,
                            // unitTypeId:this.selectRow.unitTypeId,
                            splitList: data1
                        }
                        let {data, code, msg, message} = await this.$RequestUtil.postAsync({
                            url: '/api/productionPlan/printPlan',
                            type: 'sync',
                            params,
                        })
                        if (code == 0) {
                            localStorage.setItem('printAllOrderData', JSON.stringify(data))
                            localStorage.setItem('modelType', this.printForm.modelType)
                            this.$refs['printForm'].clearValidate()
                            this.showPrintDialog = false
                            this.printOrderList1()
                        } else {
                            this.$message.error(msg || message)
                            return false
                        }

                    }
                })
            },
            async loadMaterialInfo(splitId, materialId) {
                let {code, data, message, msg} = await this.$RequestUtil.getAsync({
                    url: '/api/productionPlan/getDataForStockIn',
                    type: 'sync',
                    params: {
                        splitId,
                        materialId
                    },
                })
                if (code == 0) {
                    return data
                } else {
                    this.$message.error(message || msg)
                }
            },
            warehouseChange(ev) {
                if (ev) {
                    this.$set(this.addForm, 'warehouseId', null)
                    this.loadTreeList(ev)
                }
            },
            async loadTreeList(id) {
                let res = await this.$RequestUtil.getAsync({
                    url: '/api/warehouseController/listFormatWarehouseByWarehouseId',
                    params: {id}
                })
                if (res.data.length > 0) {
                    res.data.forEach(item => {
                        let arr = item.formatWarehouseName.split('/')
                        arr.shift()
                        arr.shift()
                        let str = arr.join('/')
                        item.warehouseName = str
                    })
                    this.warehouseList = res.data
                }
            },
            submitEditDialog() {
                this.$refs['addForm'].validate((valid) => {
                    if (valid) {
                        let params = {
                            data: {
                                splitId: this.addForm.splitId,
                                topWarehouseId: this.addForm.topWarehouseId,
                                stockInDetailList: [
                                    {
                                        warehouseId: this.addForm.warehouseId,
                                        stockInType: 1,
                                        materialId: this.addForm.materialId,
                                        splitId: this.addForm.splitId,
                                        unitTypeId: this.addForm.unitTypeId,
                                        productionBatch: this.addForm.productionBatch,
                                        productionBatchId: this.addForm.productionBatchId,
                                        amount: this.addForm.amount,
                                        timeOfStockIn: this.addForm.timeOfStockIn
                                    }
                                ],
                                remark: this.addForm.remark
                            }
                        }
                        // this.$RequestUtil.loading()
                        this.$RequestUtil.post({
                            url: '/api/stock/application/stockIn',
                            params,
                            success: res => {
                                if (res.code == 0) {
                                    this.$message.success('入库申请成功')
                                    this.cancelEditDialog()
                                    this.search()
                                    this.loadBusinessOrderPart();
                                } else {
                                    this.$RequestUtil.loading().close()
                                    this.$message.error(res.msg || res.message)
                                }
                            }
                        })
                    }
                })
            },
            cancelEditDialog() {
                this.addForm.topWarehouseId = null
                this.addForm.warehouseId = null
                this.addForm.unitTypeId = null
                this.addForm.productionBatch = null
                this.addForm.productionBatchId = null
                this.addForm.remark = ''
                this.warehouseList = []
                this.$refs['addForm'].clearValidate()
                this.showStoreDialog = false
            },
            //以下是编排任务相应跳转
            showProductionPlanEdit(row) {
                this.selectedSplit = row;
                let data = commonUtils.cloneObj(row)
                data.id = data.orderId
                data.showPage = 1
                data.deliverTime = commonUtils.timestampToDate(data.deliverTime, true)
                data.orderTime = commonUtils.timestampToDate(data.orderTime, true)
                this.$store.commit('changeOrderPage', data)
                this.$router.push({path: '/OrderMgt', params: {id: row.id}})


            },

            showState(scope) {
                // console.log(scope);
                if (
                    (scope.row.tcheckState == 1 && 0 <= scope.row.process < 100)
                    || (scope.row.tcheckState == null && 0 <= scope.row.process < 100)
                ) {
                    // console.log(scope.row)
                    // console.log(!this.show)
                    return true

                } else if (
                    (scope.row.tcheckState == 0 && scope.row.process == 100)
                    || (scope.row.tcheckState == null && scope.row.process == 100)
                    || (scope.row.tcheckState == 1 && scope.row.process == 100)
                    || (scope.row.tcheckState == 0 && 0 <= scope.row.process < 100)
                ) {
                    // console.log(this.show)
                    return false

                } else {
                    return true
                }
            },
            showCall(scope) {
                if (scope.row.stockInButtonStatus == 1) {
                    return true
                } else if ((scope.row.amount - scope.row.alreadyInAmount) == 0) {
                    return false
                } else {
                    return false
                }
            },

            //以下是进度查看任务相应跳转
            showProductionPlanView(row) {
                this.selectedSplit = row;
                let data = commonUtils.cloneObj(row)
                data.id = data.orderId
                data.showPage = 1
                data.deliverTime = commonUtils.timestampToDate(data.deliverTime, true)
                data.orderTime = commonUtils.timestampToDate(data.orderTime, true)
                this.$store.commit('changeOrderPage', data)
                // console.log(row);
                this.$router.push({path: "/OrderMgt", params: {id: row.id}})
                // this.showPage = 3;
            },
            closeSelect(val) {
                if (!val) {
                    this.workerOptionsCopy = [...this.workerOptions]
                }
            },
            async loadStoreList() {
                let res = await this.$RequestUtil.getAsync({
                    url: '/api/select/listWarehouse',
                    type: 'sync',
                    params: {},
                })
                if (res.data.next) {
                    this.tree = res.data.next
                }
            },
            filterUser(val) {
                if (val) {
                    this.workerOptionsCopy = this.workerOptions.filter(item => pinyinMatch.match(item.label, val))

                }
            },
            async closeOrderList(ev) {
                if (!ev) {
                    await this.orderRemoteMethod()
                    if (this.searchForm.orderId) {
                        let find = this.orderOptions.find(item => item.value == this.searchForm.orderId)
                        if (!find) {
                            this.orderOptions.unshift({
                                id: Number(this.searchForm.orderId),
                                label: this.selectOrderName,
                                value: Number(this.searchForm.orderId)
                            })
                        }
                    }
                }
            },
            async remoteMethod5(query) {
                this.orderLoading = true;
                await this.orderRemoteMethod(query)
                this.orderLoading = false
            },
            async remoteMethod4(query) {
                this.productLoading = true;
                await this.loadProductionCode(query)
                this.productLoading = false
            },
            async loadProductionCode(query) {
                let {data} = await this.$RequestUtil.getAsync({
                    url: '/api/select/listProductionOrderCodeByOrder',
                    params: {productionOrderCode: query, filterNoPlaned: 1},
                });
                this.productionCodeList = data;
            },
            testNum(ev) {
                this.isSumbit = true
                let n = Number(ev)
                // if((isNaN(n))||(n<=0)||(n%1!=0&&n%1!=1)){
                //   // this.$message.warning('任务ID必须为正整数')
                //   this.searchForm.id = null
                //   this.isSumbit = false
                // }
            },
            reload() {
                this.orderRemoteMethod();
                this.deviceRemoteMethod();
                this.workerRemoteMethod();
                this.$store.commit('delete_reloadPages', '/Production')
                this.$forceUpdate()
            },
            handlemyclass(row, column, rowIndex, columnIndex) {
                return 'cellheader'
            },
            showProgress(row, column, cellValue, index) {
                let all = row.partCount;
                let finished = row.qualifiedProcessCount;
                finished = finished == null ? 0 : finished;
                let ratio = (100 * finished / all);
                if (ratio > 100) {
                    ratio = 100;
                }
                return ratio == 100 ? ratio + '%' : ratio.toFixed(2) + '%';
            },
            orderSelectChange(val) {
                if (val === null || val === 0 || val === '') {
                    this.searchForm.orderCode = '';
                } else {
                    let arr = this.orderOptions;
                    if (arr.length > 0) {
                        for (let i = 0; i < arr.length; i++) {
                            if (arr[i].value === val) {
                                this.searchForm.orderCode = arr[i].label;
                                this.selectOrderName = arr[i].label
                                break;
                            }
                        }
                    }
                }
            },
            async orderRemoteMethod(query) {
                let {data} = await this.$RequestUtil.getAsync({
                    url: '/api/select/listOrder',
                    params: {orderCode: query, filterNoPlaned: 1},
                });
                this.orderOptions = data.filter(item => item.label);
                // log(this.orderOptions)
            },
            computedWidth(val) {
                let selectDown = null
                Array.from(this.$root.$el.parentNode.children).forEach(el => {
                    if (el.className.includes('el-select-dropdown')) {
                        selectDown = el
                    }
                })
                if (val) {
                    selectDown.style.width = '180px'
                } else {
                    selectDown.style.width = 'auto'
                }
            },
            deviceSelectChange(val) {
                if (val === null || val === 0 || val === '') {
                    this.searchForm.deviceName = '';
                } else {
                    let arr = this.deviceOptions;
                    if (arr.length > 0) {
                        for (let i = 0; i < arr.length; i++) {
                            if (arr[i].value === val) {
                                this.searchForm.deviceName = arr[i].label;
                                break;
                            }
                        }
                    }
                }
            },
            deviceRemoteMethod(query) {
                this.deviceLoading = true;
                setTimeout(() => {
                    this.$RequestUtil.get({
                        url: '/api/select/listDevice',
                        params: {
                            deviceName: query,
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.deviceOptions = res.data;
                                this.deviceLoading = false;
                            }
                        }
                    });
                }, 200);
            },
            workerSelectChange(val) {
                if (val === null || val === 0 || val === '') {
                    this.searchForm.workerName = '';
                } else {
                    let arr = this.workerOptions;
                    if (arr.length > 0) {
                        for (let i = 0; i < arr.length; i++) {
                            if (arr[i].value === val) {
                                this.searchForm.workerName = arr[i].label;
                                break;
                            }
                        }
                    }
                }
            },
            workerRemoteMethod(query) {
                this.workerLoading = true;
                setTimeout(() => {
                    this.$RequestUtil.get({
                        url: '/api/select/listWorker',
                        params: {
                            workerName: query,
                            noFilterDeparture: 1
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.workerOptions = res.data;
                                this.workerOptionsCopy = CommonUtils.cloneObj(res.data)
                                this.workerLoading = false;
                            }
                        }
                    });
                }, 200);
            },
            importOrder() {
                this.showImportOrderView = true;
            },
            pageChange(pageNum) {
                this.$set(this, 'searchForm', commonUtils.cloneObj(this.searchCase));
                this.tableCurrentPage = pageNum;
                this.search(pageNum);
            },
            //排序改变事件
            sortChangeEvent(param) {
                // console.log('排序',param)
                let orderType = param.order;
                let orderColumn = param.prop;
                this.orderColumn = orderColumn;
                if (orderType == 'descending') {
                    this.orderType = 'DESC';
                } else if (orderType == 'ascending') {
                    this.orderType = 'ASC';
                } else {
                    this.orderType = orderType;
                    this.orderColumn = null
                }

                this.search(1);
                this.tableCurrentPage = 1
            },
            //
            // mouseShow(prev){
            //   console.log(prev);
            //   if(this.mouseData == prev){
            //
            //   }
            //
            //
            // },

            parseProductionType(row) {
                let type = row.productionType
                // console.log(row)

                // log(type);
                let val = ''
                switch (type) {
                    case 1:
                        val = '自产'
                        break;
                    case 2:
                        val = '外协'
                        break;
                    case 3:
                        val = '自产+外协'
                        break;
                    case 4:
                        val = '外购'
                        break;
                }
                return val
            },
            //列表查询
            async search(pageNum) {
                // if (this.searchForm.materialCode) {
                //   this.testNum(this.searchForm.materialCode)
                // }
                // if (!this.isSumbit) {
                //   this.isSumbit = true
                //   return
                // }
                if (pageNum == null || pageNum instanceof KeyboardEvent) {
                    pageNum = 1;
                }
                let form = this.searchForm;
                let params = {
                    materialCode: form.materialCode,
                    orderCode: form.orderCode,
                    productionCode: form.productionCode,
                    productionType: form.productionType,
                    processType: form.processType,
                    routeName: form.routeName,
                    postInOrder: form.postInOrder,
                    tcheckState: form.tcheckState,
                    alreadyInStockAmount: form.alreadyInStockAmount,
                    pageNum: this.tableCurrentPage,
                    pageSize: this.page.pageSize,
                    productionBatchCode: form.productionBatchCode,
                    orderType: this.orderType,
                    orderColumn: this.orderColumn,
                    isWeb: true
                };
                this.$RequestUtil.get({
                    url: '/api/order/listSplitProcess',
                    type: 'sync',
                    params: params,
                    success: (res) => {
                        // console.log(res);
                        // console.log(res.data);
                        if (res.code != 0) {
                            this.$message.error(res.message);
                            return;
                        }
                        this.tableData = res.data;
                        // console.log(res.data);

                        this.tableData.forEach(item => {
                            if (!item.workerName) {
                                item.workerName = ''
                            }
                            if (!item.procedureName) {
                                item.procedureName = ''
                            } else {
                                if (item.productionType == 2 || item.productionType == 4) {
                                    item.procedureName = item.procedureName + '等'
                                }
                            }

                            if (item.productionType == 3) {
                                if (!item.deviceName) {
                                    item.deviceName = ''
                                }
                            } else {
                                if (!item.deviceName) {
                                    item.deviceName = ''
                                }
                            }

                            item.class = ''
                            if (item.process == null) {
                                item.process == 0
                            }
                            if (item.process == 0) {
                                item.color = 'rgb(244,246,245)'

                            } else if (item.process > 0 && item.process < 100) {
                                item.process = Number(item.process)
                                item.color = 'rgb(255,186,1)'
                            } else if (item.process == 100) {
                                item.color = 'rgb(108,213,137)'
                            }
                            item.process = Number(item.process)

                        })

                        this.page.currentPage = res.data.pageNum;
                        this.page.total = res.totalPages;
                        if (this.tableData.length > 0) {
                            this.page.isShow = true;
                        }
                        if (this.page.total == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }
                });
            },
            // exportList(){
            //   this.$confirm('是否确认导出?', '提示', {
            //     cancelButtonClass: "btn-custom-cancel",
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            //   }).then(async () => {
            //     let form = this.searchForm;
            //     let params = {
            //       id: form.id,
            //       orderId: form.orderId,
            //       orderCode: form.orderCode,
            //       devicePid: form.devicePid,
            //       deviceId: form.deviceId,
            //       workerId: form.workerId,
            //       workerName: form.workerName,
            //       orderType: this.orderType,
            //       orderColumn: this.orderColumn,
            //       productionOrderCode:form.productionOrderCode,
            //       type:form.type,
            //       token:localStorage.getItem("token")
            //     }
            //     let str = '?'
            //     for(let p in params){
            //       if(params[p]){
            //         str+=`${p}=${params[p]}&`
            //       }
            //     }
            //     let {code,data} = await this.$RequestUtil.getAsync({url: "/api/auth/checkToken",type:'sync',params: {},})
            //     if(data==0||(code!=0)){
            //       this.$message.error('当前登录已过期')
            //       localStorage.removeItem("token");
            //       localStorage.removeItem("username");
            //       localStorage.removeItem("permission");
            //       this.$router.push({path:"/login"})
            //       return
            //     }
            //     if(str.endsWith('&')){
            //       str = str.slice(0,str.length-1)
            //       window.location.href = '/api/productionPlan/exportProductionPlan'+str;
            //     }
            //
            //
            //   }).catch(() => {});
            // },
            //清空查询条件
            clearSearch() {
                let form = this.searchForm;
                form.materialCode = '';
                form.orderCode = '';
                form.productionCode = '';
                form.productionType = null;
                form.routeName = '';
                form.postInOrder = null;
                form.processType = null;
                form.tcheckState = null;
                form.alreadyInStockAmount = null
                form.productionBatchCode = null
            },
            clickSearch() {
                this.searchCase = commonUtils.cloneObj(this.searchForm)
                this.tableCurrentPage = 1;
                this.search(1);

            },
            viewQRCode: function (rowData) {
                this.qrCode = `${this.$Global.baseUrl}/api/qrcode/getInfo?type=planDetail&id=${rowData.id}`
                this.qrCodeDialogVisible = true;
                this.qrOrderCode = rowData.orderCode ? rowData.orderCode : '';
                this.qrProductionOrderCode = rowData.productionOrderCode ? rowData.productionOrderCode : '';
                this.qrProductCode = rowData.productCode ? rowData.productCode : '';
                this.qrPartCode = rowData.partCode ? rowData.partCode : '';
            },

            printQRCode: function () {
                var ss = this.$refs.qrcodediv;
                var imageToPrint = document.getElementById("qrcode").childNodes[0].childNodes[0]; //将要被打印的图片
                var printWindow = window.open(""); //新打开一个空窗口
                printWindow.document.write("<img src='" + imageToPrint.toDataURL() + "'/>"); //将图片添加进新的窗口
                this.qrOrderCode && printWindow.document.write("<div style='margin-top:5px'><span>订单号:" + this.qrOrderCode + "</span></div>");
                this.qrProductionOrderCode && printWindow.document.write("<div style='margin-top:5px' ><span>生产/销售单号:" + this.qrProductionOrderCode + "</span></div>");
                this.qrProductCode && printWindow.document.write("<div style='margin-top:5px;margin-bottom:5px;'><span>产品编码:" + this.qrProductCode + "</span></div>");
                this.qrPartCode && printWindow.document.write("<div style='margin-top:5px;margin-bottom:5px;'><span>零件编码:" + this.qrPartCode + "</span></div>");
                printWindow.document.close(); //在IE浏览器中使用必须添加这一句
                printWindow.focus(); //在IE浏览器中使用必须添加这一句
                setTimeout(function () {
                    printWindow.document.body.style.textAlign = 'center'
                    printWindow.print(); //打印
                    printWindow.close(); //关闭窗口
                }, 0);
            }
        },
        watch: {},

        filters: {
            showType(value) {
                if (value == 0) {
                    return '产品'
                } else if (value == 1) {
                    return '零件'
                }
            },
            PostInOrder(postInOrder) {
                if (postInOrder == true) {
                    return '是'
                } else if (postInOrder == false) {
                    return '否'
                }

            },


            filterProductionType(value) {
                if (value == 1) {
                    return '自产'
                } else if (value == 2) {
                    return '外协'
                } else if (value == 3) {
                    return '自产+外协'
                } else if (value == 4) {
                    return '外购'
                }
            },
        }
    }
</script>

<style scoped>
    .operateBtn-wrap {
        margin-top: 20px;
        margin-bottom: 10px;
    }


    .search-input-row {
        margin-top: 10px;
    }


    .search-input-wrap {
        margin-bottom: 20px;
    }

    .page {
        display: flex;
        justify-content: flex-end;
    }

    .total_page {
        margin-top: 20px;
        margin-right: 26px;
        color: #606266;
        font-size: 14px;
    }

    @media screen and (max-width: 1380px) {
        .page {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 30px;
        }
    }

    @media screen and (max-width: 1366px) {

        .span_flex {
            display: flex;
            width: 100%;
        }

        .span_flex .el-input {
            top: -3px !important;
        }

        .y_inputWidth .el-input {
            width: 80% !important;
        }

    }

    .search-input-wrap .title11 {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
        width: 70px;
        display: inline-block;
        text-align: right;
    }

    .qrcode_div {
        text-align: center;
    }

    #schedule {
        height: 106%;
    }

    .el-button--text {
        color: #409EFF;
        background: 0 0;
        padding-left: 0;
        padding-right: 0;
    }
</style>

<style>
    .search-input-wrap .el-button--mini, .el-button--mini.is-round {
        padding: 7px 10px;
    }

    /* #production .el-select{
        width: 100%;
    } */
    @media screen and (max-width: 1366px) {
        #production {
            max-height: 698px;
        }

        #production .el-button + .el-button {
            margin-left: 0px;
        }

    }

    .head-cell-class .cell {
        margin-left: 5px
    }

    .head-cell-class .cell {
        margin-left: 5px
    }

    .cell-class .cell {
        position: relative;
        top: -12px;
        left: 4px;
    }

    .width180 {
        width: 180px;
    }

    .ellipsis-text .el-form-item__content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .y_table {
        display: table;
    }

    /* .y_table_span {
        width: 80px !important;
        height: 31px;
        line-height: 31px;
        display: inline-block;
        vertical-align: middle;
    } */

    .y_table_cell {
        display: table-cell;
        width: 100% !important;
        vertical-align: middle;
    }

    .y_table_cell .el-date-editor.el-input__inner {
        width: 100% !important;
    }

    .y_table_cell .el-date-editor.el-input {
        width: 100% !important;
    }

    .y_table .el-autocomplete {
        width: 100% !important;
    }

    .el-table--small .test-margin {
        padding: 20px 0 0 0 !important;
    }

    .y_Schedule_flex {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/views/Schedule.vue